export default __webpack_public_path__ + "8571ad397e560780ade3dc29ebefbb80.svg";